import React from "react";
import { Link } from "react-router-dom";

const FEATURED_DESCRIPTION_MAX_LENGTH = 100;

function truncateToLength(text: string, maxLength: number): string {
  const trimmed = text.trim();
  if (trimmed.length <= maxLength) return trimmed;
  const cut = trimmed.slice(0, maxLength).trim();
  const lastSpace = cut.lastIndexOf(" ");
  if (lastSpace > maxLength * 0.6) {
    return `${cut.slice(0, lastSpace)}…`;
  }
  return `${cut}…`;
}

export interface FeaturedInitiativeSpotlightProps {
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  /** Link to initiative detail; when set, shows "Know More" button */
  detailHref?: string;
  /** Max characters for description; default 100 */
  descriptionMaxLength?: number;
}

/**
 * Featured initiative block: ~100-char description on the left, image card on the right.
 * Optional "Know More" button when detailHref is provided.
 */
const FeaturedInitiativeSpotlight: React.FC<FeaturedInitiativeSpotlightProps> = ({
  title,
  description,
  image,
  imageAlt,
  detailHref,
  descriptionMaxLength = FEATURED_DESCRIPTION_MAX_LENGTH,
}) => {
  const shortDescription = truncateToLength(description || "", descriptionMaxLength);

  return (
    <div className="featured-initiative-spotlight">
      <div className="row align-items-center g-4">
        <div className="col-lg-4 col-md-6 order-2 order-md-1">
          <div className="featured-initiative-spotlight__content">
            <h3 className="featured-initiative-spotlight__title">{title}</h3>
            <p className="featured-initiative-spotlight__description">{shortDescription}</p>
            {detailHref && (
              <div className="featured-initiative-spotlight__action mt-3">
                <Link to={detailHref} className="btn-main btn-line">
                  Know More <i className="fas fa-arrow-right ms-2" aria-hidden />
                </Link>
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-8 col-md-6 order-1 order-md-2">
          <div className="initiative-card-image">
            <img src={image} alt={imageAlt} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedInitiativeSpotlight;
